var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeriesType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 26.6665V13.3332C34.9994 12.7486 34.8451 12.1745 34.5526 11.6684C34.26 11.1624 33.8396 10.7421 33.3333 10.4498L21.6667 3.78316C21.1599 3.4906 20.5851 3.33658 20 3.33658C19.4149 3.33658 18.8401 3.4906 18.3333 3.78316L6.66667 10.4498C6.16044 10.7421 5.73997 11.1624 5.44744 11.6684C5.1549 12.1745 5.0006 12.7486 5 13.3332V26.6665C5.0006 27.251 5.1549 27.8251 5.44744 28.3312C5.73997 28.8373 6.16044 29.2576 6.66667 29.5498L18.3333 36.2165C18.8401 36.5091 19.4149 36.6631 20 36.6631C20.5851 36.6631 21.1599 36.5091 21.6667 36.2165L33.3333 29.5498C33.8396 29.2576 34.26 28.8373 34.5526 28.3312C34.8451 27.8251 34.9994 27.251 35 26.6665Z",
    stroke: "#194383",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.6665C23.6819 26.6665 26.6667 23.6817 26.6667 19.9998C26.6667 16.3179 23.6819 13.3332 20 13.3332C16.3181 13.3332 13.3333 16.3179 13.3333 19.9998C13.3333 23.6817 16.3181 26.6665 20 26.6665Z",
    stroke: "#194383",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeriesType);
export default __webpack_public_path__ + "static/media/series_type.85bf8f136a29ce5a02f870847ad45a34.svg";
export { ForwardRef as ReactComponent };